import { useId, useState } from 'react';

/** Controlled horizontal content tabs. Manual activation: Enter/Space or click. */
export default function Tabs({ label, items, value, onValueChange, children }) {
  const prefix = useId();
  const [rovingId, setRovingId] = useState(null);
  const enabled = items.filter(item => !item.disabled);
  const selected = enabled.find(item => item.id === value) || enabled[0];
  const focusId = enabled.some(item => item.id === rovingId) ? rovingId : selected?.id;

  const moveFocus = (event, id) => {
    const current = enabled.findIndex(item => item.id === id);
    const next = {
      ArrowRight: (current + 1) % enabled.length,
      ArrowLeft: (current - 1 + enabled.length) % enabled.length,
      Home: 0,
      End: enabled.length - 1,
    }[event.key];
    if (next === undefined) return; // Up/Down scroll; native Enter/Space clicks.
    event.preventDefault();
    const index = items.indexOf(enabled[next]);
    const target = document.getElementById(`${prefix}-tab-${index}`);
    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };

  return <div className="fc-tabs">
    <div className="fc-tab-list" role="tablist" aria-label={label} aria-orientation="horizontal"
      onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setRovingId(null); }}>
      {items.map((item, index) => <button key={item.id} type="button" role="tab"
        id={`${prefix}-tab-${index}`} aria-controls={`${prefix}-panel-${index}`}
        aria-selected={selected?.id === item.id} disabled={item.disabled}
        tabIndex={!item.disabled && focusId === item.id ? 0 : -1} className="fc-tab"
        onFocus={() => setRovingId(item.id)} onKeyDown={event => moveFocus(event, item.id)}
        onClick={() => onValueChange(item.id)}>{item.label}</button>)}
    </div>
    {items.map((item, index) => <div key={item.id} id={`${prefix}-panel-${index}`} role="tabpanel"
      aria-labelledby={`${prefix}-tab-${index}`} hidden={selected?.id !== item.id}
      tabIndex={0} className="fc-tab-panel">{children !== undefined
        ? (selected?.id === item.id ? children : null)
        : item.content}</div>)}
  </div>;
}
